import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "md:text-center max-w-2xl md:mx-auto mb-12" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" }
const _hoisted_4 = { class: "flex items-start gap-3" }
const _hoisted_5 = { class: "text-base/7" }

import { computed } from "vue";
import { CssVarColors } from "@/shared/themes/CssVarColors.interface";
import { PageBlock } from "@/views/blocks/PageBlock.interface";
import EditableElement from "@/views/page/EditableElement.vue";

// Import shared components
import Section from "@/views/blocks/shared/section/layout/section/Section.vue";
import FullSpacing from "@/views/blocks/shared/section/layout/spacing/FullSpacing.vue";
import Heading from "@/views/blocks/shared/section/typography/heading/Heading.vue";
import Paragraph from "@/views/blocks/shared/section/typography/paragraph/Paragraph.vue";
import Image from "@/views/blocks/shared/section/image/Image.vue";

import type { WithLargeScreenshotProps } from "./WithLargeScreenshotProps";


export default /*@__PURE__*/_defineComponent({
  __name: 'WithLargeScreenshot',
  props: {
    block: {},
    pageColors: {}
  },
  setup(__props: any) {

const props = __props;

const dataValues = computed(() => props.block.dataValues);
const styleValues = computed(() => props.block.styleValues);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Section, {
    id: _ctx.block.webId,
    "background-color": styleValues.value.background
  }, {
    default: _withCtx(() => [
      _createVNode(FullSpacing, { class: "max-w-7xl mx-auto" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (!dataValues.value.tag.isHidden)
              ? (_openBlock(), _createBlock(EditableElement, {
                  key: 0,
                  blockId: _ctx.block.id,
                  "field-name": "tag"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", {
                      style: _normalizeStyle({ color: styleValues.value.brand }),
                      class: "font-semibold mb-4"
                    }, _toDisplayString(dataValues.value.tag.data.text), 5)
                  ]),
                  _: 1
                }, 8, ["blockId"]))
              : _createCommentVNode("", true),
            (!dataValues.value.title.isHidden)
              ? (_openBlock(), _createBlock(EditableElement, {
                  key: 1,
                  blockId: _ctx.block.id,
                  "field-name": "title"
                }, {
                  default: _withCtx(() => [
                    _createVNode(Heading, {
                      text: dataValues.value.title.data.text,
                      tag: dataValues.value.title.data.tag,
                      "text-color": styleValues.value.text,
                      class: "mb-6 text-4xl sm:text-5xl"
                    }, null, 8, ["text", "tag", "text-color"])
                  ]),
                  _: 1
                }, 8, ["blockId"]))
              : _createCommentVNode("", true),
            (!dataValues.value.description.isHidden)
              ? (_openBlock(), _createBlock(EditableElement, {
                  key: 2,
                  blockId: _ctx.block.id,
                  "field-name": "description"
                }, {
                  default: _withCtx(() => [
                    _createVNode(Paragraph, {
                      text: dataValues.value.description.data.text,
                      "text-color": styleValues.value.text,
                      class: "text-lg opacity-70"
                    }, null, 8, ["text", "text-color"])
                  ]),
                  _: 1
                }, 8, ["blockId"]))
              : _createCommentVNode("", true)
          ]),
          (!dataValues.value.image.isHidden)
            ? (_openBlock(), _createBlock(EditableElement, {
                key: 0,
                blockId: _ctx.block.id,
                "field-name": "image"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(Image, {
                      src: dataValues.value.image.data.src,
                      alt: dataValues.value.image.data.alt,
                      class: "mx-auto w-full mb-8"
                    }, null, 8, ["src", "alt"]),
                    _createElementVNode("div", {
                      class: "absolute bottom-0 left-0 right-0 h-32 sm:h-96 bg-gradient-to-t",
                      style: _normalizeStyle({
                            backgroundImage: `linear-gradient(to top, ${styleValues.value.background} 0%, transparent 100%)`,
                        })
                    }, null, 4)
                  ])
                ]),
                _: 1
              }, 8, ["blockId"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataValues.value.features.data.items, (feature) => {
              return (_openBlock(), _createBlock(EditableElement, {
                key: feature.id,
                blockId: _ctx.block.id,
                "field-name": `features_${feature.id}`,
                hideable: false
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(Image, {
                      src: feature.iconSrc,
                      alt: "",
                      class: "mt-1 w-5"
                    }, null, 8, ["src"]),
                    _createElementVNode("p", _hoisted_5, [
                      _createElementVNode("span", {
                        class: "font-semibold",
                        style: _normalizeStyle({ color: styleValues.value.text })
                      }, _toDisplayString(feature.title), 5),
                      _cache[0] || (_cache[0] = _createTextVNode(" " + _toDisplayString(" ") + " ")),
                      _createElementVNode("span", {
                        style: _normalizeStyle({ color: styleValues.value.text }),
                        class: "opacity-70"
                      }, _toDisplayString(feature.description), 5)
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["blockId", "field-name"]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["id", "background-color"]))
}
}

})